export default{
    checkPhone(value) {
        var reg = 11 && /^1\d{10}$/;
        if(reg.test(value)){
            return true;
        }else{
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/util/pubUtils.js